import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { BrandLockup } from "./BrandLockup";
import { scrollToId } from "../lib/scroll";

const links = [
  { label: "O Programa", id: "programa", testid: "nav-link-programa" },
  { label: "Preços", id: "precos", testid: "nav-link-precos" },
  { label: "FAQ", id: "faq", testid: "nav-link-faq" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
      data-testid="site-header"
      className={`fixed inset-x-0 top-0 z-50 border-b backdrop-blur-xl transition-colors duration-500 ${
        scrolled ? "border-[#34d186]/20 bg-[#ffffff]/85" : "border-transparent bg-transparent"
      }`}
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-5 py-4 sm:px-8">
        <button onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })} data-testid="header-brand-button" aria-label="Voltar ao topo">
          <BrandLockup />
        </button>
        <nav className="hidden items-center gap-8 md:flex" data-testid="main-nav">
          {links.map((l) => (
            <button
              key={l.id}
              data-testid={l.testid}
              onClick={() => scrollToId(l.id)}
              className="text-sm text-[#737373] transition-colors duration-300 hover:text-[#34d186]"
            >
              {l.label}
            </button>
          ))}
        </nav>
        <button
          data-testid="header-cta-button"
          onClick={() => scrollToId("inscricao")}
          className="group hidden items-center gap-2 rounded-full bg-[#34d186] px-5 py-2.5 text-sm font-semibold text-[#ffffff] transition-all duration-300 hover:bg-[#00c46a] hover:shadow-[0_0_28px_rgba(52,209,134,0.45)] sm:inline-flex"
        >
          Quero ser motorista Bolt
          <ArrowRight size={15} className="transition-transform duration-300 group-hover:translate-x-1" />
        </button>
      </div>
    </motion.header>
  );
}
